import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
}

const AnimatedBackground: FC<Props> = ({ className }) => {
  return (
    <AnimatePresence>
      <div
        className={twMerge('relative overflow-hidden rounded-full', className)}
      >
        {/* Animated gradient layer */}
        <motion.div
          className='absolute inset-0'
          style={{
            background: `
            radial-gradient(
              circle at 50% 0%,
              rgba(83, 152, 247, 0.55) 0%,
              rgba(114, 39, 241, 0.45) 40%,
              rgba(125, 16, 166, 0.55) 70%
            )
          `,
            backgroundSize: '100% 200%',
          }}
          animate={{
            y: ['0%', '-50%', '0%'],
          }}
          transition={{
            duration: 5,
            ease: 'linear',
            repeat: Infinity,
          }}
        />
      </div>
    </AnimatePresence>
  );
};

export default AnimatedBackground;
